import React from 'react';
import './Home.css';
import 'antd/dist/antd.css';
import './NearTermActivities';
import '../../containers/AboutUs/AboutUs';
import "../../containers/Activities/Activities1"
import { Carousel } from 'antd';
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux"
import actions from "../../store/actions"
import { CalendarBusy, GetHomeBanner, GetExternalWebpage, ActivityService } from "../../api/api";
import moment from "moment"
import VlecImg from '../../component/VlecImg'
import Calendar from '../../component/Calendar'
import bj from '../../static/images/beijing-2@2x.png'
import sh from '../../static/images/shanghai-4@2x.png'
import sz from '../../static/images/shenzhen1@2x.png'
import tj from '../../static/images/tianjin@2x.png'

class Home extends React.Component {

    state = {
        darBusy: [],
        GetHomeBanner: [],
        GetExternalWebpage: [],
        year: "",
        month: "",
        day: "",
        aryDate: [],
        chinese: true,
        NewList: [],
        timeInterval: { startDate: "2018-10-20", endDate: "2018-12-20" },//模拟区间时间
        fullTime: [],//模拟申请已满的数据
        ActivityList: [],
        showTip: false,
        showModalTip: false,
        cards: [
            {
                active: false,
                bg: bj,
                pre: 'bj',
                title: 'intl-card-fc',
                enableDate: 'intl-card-enable2019'
            },
            {
                active: false,
                bg: sh,
                pre: 'sh',
                title: 'intl-card-shfc',
                enableDate: 'intl-card-enable2021'
            },
            {
                active: false,
                bg: sz,
                pre: 'sz',
                title: 'intl-card-szfc',
                enableDate: 'intl-card-enable2023'
            },
            {
                active: false,
                bg: tj,
                pre: 'tj',
                title: 'intl-card-tjfc',
                enableDate: 'intl-card-enable2023'
            },
        ]
    };
    Slider = null;



    currentDay = {}




    /*点击当前时间，进行跳转到团队申请页面*/

    handleBack1 = (ID) => {
        this.props.history.push("/NearTerm", { ID });
    };

    handleBack2 = (e) => {
        e.preventDefault();
        window.scrollTo(50, 0);
        this.props.history.push("/Center");

    };

    componentWillMount() {
        /*const {cleanValue}=this.props*/
        // 初始化时  获取当天的日期
        // let year = new Date().getFullYear(),
        //     month = new Date().getMonth() + 1,
        //     day = new Date().getDate(),
        //     ary = this.getTime(year, month);
        // console.log(day);
        let value = { cleanVis: true };
        this.props.Clean(value);

        // this.setState({
        //     year,
        //     month,
        //     day,
        //     aryDate: ary

        // });

    }

    Goto(id) {

        this.props.history.push("/ActivityDetail/" + id);
    }
    componentDidMount() {
        /*轮播图*/
        GetHomeBanner().then((response) => {
          console.log(response,'轮博')
            let data = response.DataResult;
            this.setState({
                GetHomeBanner: data
            }, () => {

                console.log(this.Slider);
                this.Slider.innerSlider.slickGoTo(0);
            });
        });
        /*新闻图*/
        GetExternalWebpage().then((response) => {
          console.log(response,'新闻')
            let data = response.DataResult;
            this.setState({
                GetExternalWebpage: data
            }, () => {

            })
        });

        // //默认获取区间时间,申请已满//
        // CalendarBusy(`${year}-${month}-${day}`).then((response) => {
        //     let data = response.DataResult;
        //     this.setState({
        //         timeInterval: {startDate: `${year}-${month}-${day}`, endDate: data.ApplyMaxDate},
        //         fullTime: data.NotApplyDateList
        //     })
        // });
        //
        ActivityService.GetList({ PageIndex: 1, PageSize: 3 }).then(response => {
            if (response.DataResult) {

                this.setState({
                    ActivityList: response.DataResult.DataList

                })
            }

        });
    }
    enterCard(_index) {
        this.state.cards.map((item, index) => {
            item.active = false;
            if (_index === index) {
                item.active = true;
            }
            return item;
        });
        this.setState({
            cards: this.state.cards
        });
    }
    moveCard(_index) {
        this.state.cards[_index].active = false;
        this.setState({
            cards: this.state.cards
        });
    }
    clickCard(item) {
        switch (item.pre) {
            case 'bj':
                this.props.history.push('/Center');
                break;
            case 'sh':
                this.props.history.push('/shcenter');
                break;
            case 'sz':
                this.props.history.push('/szcenter');
                break;
            case 'tj':
                this.props.history.push('/tjcenter');
                break;
            default:
                break;
        }
    }
    render() {
        // const aryDate = this.getTime(this.state.year, this.state.month);
        return (<div className="HomeBox">

            {/*轮播图片*/}
            <div style={{ width: "100%", height: "100%" }}>
                <Carousel autoplay
                    ref={el => { this.Slider = el }}
                >
                    {
                        this.state.GetHomeBanner.map((item) => {
                            return <div key={item.ID}>
                                {/* <a href={item.URL}> */}
                                <VlecImg onClick={() => { item.URL && (window.open(item.URL)); }} src={item.ImagePath} alt="" style={{ width: "100%", height: "100%" }} />
                                {/* </a> */}

                            </div>
                        })}
                </Carousel>
            </div>
            {/*第二部分*/}
            <div className="indexDiv datetime_box">
                <div className="center home-center home_datebox">
                    {/*左图*/}
                    <div className="indexUs">
                        <div className="indexUs_con">
                            <h4>
                                <FormattedMessage
                                    id="intl-Home-AboutUs"
                                /></h4>
                            <p>
                                <FormattedMessage
                                    id="intl-Home-aboutPart1"
                                /><br />
                                <FormattedMessage
                                    id="intl-Home-aboutPart2"
                                /><br />
                                <FormattedMessage
                                    id="intl-Home-aboutPart3"
                                /><br />
                                <FormattedMessage
                                    id="intl-Home-aboutPart4"
                                /><br />
                                <FormattedMessage
                                    id="intl-Home-aboutPart5"
                                /><br />
                                <FormattedMessage
                                    id="intl-Home-aboutPart6"
                                />

                            </p>
                            {/* <a className="btn btn-hollow" onClick={this.handleBack2}>
                            <FormattedMessage
                                id="intl-Home-JOINLENOVO"
                            /></a> */}
                            {this.props.local === 'en' ? null : <div style={{ width: '200px', display: 'grid' }}>


                                <img src='images/qrcode_fc.jpg' width="200px"></img>
                                <span style={{ margin: '0 auto' }}>扫描二维码关注联想未来中心</span>
                            </div>}
                        </div>
                    </div>
                    {/* <Calendar local={this.props.local} history={this.props.history} /> */}
                    <div className='card-container'>
                        {
                            this.state.cards.map((item, index) => (
                                <div onMouseLeave={this.moveCard.bind(this,index)} onClick={this.clickCard.bind(this, item)} onMouseEnter={this.enterCard.bind(this, index)} className={item.active ? `activecard ${item.pre}-activecard` : `card ${item.pre}-card`}>
                                    <div style={{ marginTop: item.active ? '49px' : '43.4px' }}>
                                        <img className='card-img' src={item.bg} />
                                    </div>
                                    <p className='card-title'><FormattedMessage id={item.title} /></p>
                                    <p className='card-date'><FormattedMessage id={item.enableDate} /></p>
                                </div>
                            ))
                        }
                        {/* <div className='card sh-card'>
                            <div style={{ marginTop: '62px' }}>
                                <img className='card-img' src={sh} />
                            </div>
                            <p className='card-title'>联想上海未来中心</p>
                            <p className='card-date'>2021年启用</p>
                        </div>
                        <div className='card sz-card'>
                            <div style={{ marginTop: '62px' }}>
                                <img className='card-img' src={sz} />
                            </div>
                            <p className='card-title'>联想深圳未来中心</p>
                            <p className='card-date'>敬请期待...</p>
                        </div>
                        <div className='activecard bj-activecard'>
                            <div style={{ marginTop: '70px' }}>
                                <img className='card-img' src={bj} />
                            </div>
                            <p className='card-title'>联想北京未来中心</p>
                            <p className='card-date'>2019年启用</p>
                        </div> */}

                    </div>
                </div>
            </div>
            {/*新闻图片*/}
            <div className="indexPhoto">
                <dl>
                    {this.state.GetExternalWebpage ? this.state.GetExternalWebpage.map((item, index,) => {
                        if (index === 0) {
                            return <dt key={item.id}>
                                <a onClick={() => {
                                    this.handleBack1(item.id)
                                }}>
                                    <VlecImg src={item.imagePath} alt="" />
                                    <span className="indexPhoto-title">{
                                        this.props.local === "en" ? item.titleEn : item.titleCn}</span>
                                </a>
                            </dt>
                        } else {
                            return <dd key={item.id}>
                                <a onClick={() => {
                                    this.handleBack1(item.id)
                                }}>
                                    <VlecImg src={item.imagePath} alt="" />
                                    <span
                                        className="indexPhoto-title">{this.props.local === "en" ? item.titleEn : item.titleCn}</span>
                                </a>

                            </dd>
                        }

                    }):[]}
                </dl>
            </div>
            {/*ACITIVITES*/}
            {this.props.local === 'zh' ? <div className="indexDiv Acitivites">
                <div className="home-center home_Acitivites" style={{ display: 'none' }}>

                    <div className="titleH4">
                        <h4>Create Possibilities</h4>
                        <p><FormattedMessage id="intl-home-Possibilities1" /><br />
                            <FormattedMessage id="intl-home-Possibilities2" /><br />
                            <FormattedMessage id="intl-home-Possibilities3" /><br />
                        </p>


                    </div>

                    <ul className="indexAcitivites">
                        {
                            this.state.ActivityList.map((item, i) => (
                                <li key={i}>
                                    <div className="iA_con">
                                        <h4> <a href="javascript:void(0)" title={item.ActivityName} className="activityTitle" onClick={this.Goto.bind(this, item.ID)}>{item.ActivityName}</a>
                                        </h4>

                                        <p>
                                            <span className="iA_Text">{moment(item.ActivityDate).format('YYYY.MM.DD')}</span>
                                            <span><FormattedMessage id="upper-limit" />:{item.SignUpPeopleNumberTop}</span>
                                        </p>
                                        <p><a href="javascript:void(0)" onClick={this.Goto.bind(this, item.ID)}>
                                            {/*  <FormattedMessage
                                     id="intl-Home-Alienum"
                                 /> */}
                                            {item.ActivityContentText}
                                        </a>
                                        </p>
                                    </div>
                                </li>
                            ))
                        }

                    </ul>
                    <p className="indexAcitivites-more">
                        <a className="btn btn-hollow" onClick={() => this.props.history.push("/Event")}>
                            <FormattedMessage
                                id="intl-Home-MORE"
                            /></a>
                        {/* <a className="btn btn-hollow"  onClick={()=>window.open('https://mp.weixin.qq.com/s/8hnpMbLUd1x8thAXHdqiCw')}>
                            <FormattedMessage
                                id="intl-Home-MORE"
                            /></a> */}
                    </p>
                </div>
            </div> : ""}
        </div>)
    }
}

export default connect(state => ({ ...state.Home, ...state.Language }), { ...actions.Home, ...actions.Language })(Home)



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js